import auth from "./endpoints/auth";
import profile from "./endpoints/profile";
import notifications from "./endpoints/notifications";
import customers from "./endpoints/customers";
import city from "./endpoints/city";
import users from "./endpoints/users";
import reports from "./endpoints/reports";
import statistics from "./endpoints/statistics";
import subscriptions from "./endpoints/subscriptions";
import cabinets from "./endpoints/cabinets";
import operations from "./endpoints/operations";
import permissionsRoles from "./endpoints/permissionsRoles";
import task from "./endpoints/task";
import expiry_customers from "./endpoints/expiry-customers";
import services_status from "./endpoints/services-status";
import call_customer_history from "./endpoints/call-customer-history";
import clients from "./endpoints/clients";
import offers from "./endpoints/offers";
import subscriptions_services from "./endpoints/subscriptions-services";
import announcement from "./endpoints/announcement";
import subscriptions_price from "./endpoints/subscriptions-price";

const repositories = {
  customers,
  city,
  users,
  profile,
  auth,
  notifications,
  reports,
  statistics,
  subscriptions,
  cabinets,
  operations,
  permissionsRoles,
  task,
  expiry_customers,
  services_status,
  call_customer_history,
  clients,
  subscriptions_services,
  offers,
  announcement,
  subscriptions_price
};

export const factory = {
  get: (name) => repositories[name],
};
